import {http} from '@/http'

const resource = "/api";

export default {
  saveQuiz(userId, questions, timeDurationQuestion) {
    return http.post(`${resource}/Question/save-questionnaire`, {userId, questions, timeDurationQuestion})
  },
}
